var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16981_73227)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.6667,
    height: 96.6667,
    rx: 48.3333,
    fill: "#B7E1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4394 102L25 73.2424L58.9561 29L98 72.1364C96.3409 74.9015 90.8106 83.197 81.4091 91.4924C72.0259 99.7717 57.6288 102 50.4394 102Z",
    fill: "#93D2EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6491 48.7065C58.9062 46.5167 61.8125 42.1242 61.8125 37.0625C61.8125 29.8138 55.8523 23.9375 48.5 23.9375C41.1477 23.9375 35.1875 29.8138 35.1875 37.0625C35.1875 42.2759 38.2705 46.7793 42.737 48.8973C38.6422 50.0426 34.6954 52.2554 31.8763 55.3681C27.6035 60.0858 25.2031 66.4844 25.2031 73.1562H72.9062C72.9062 66.4844 70.5058 60.0858 66.2331 55.3681C63.2483 52.0724 58.9994 49.7856 54.6491 48.7065Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16981_73227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.6667,
    height: 96.6667,
    rx: 48.3333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.3cd026552e26738a3d788dd7cb3c6b81.svg";
export { ForwardRef as ReactComponent };